import React from 'react';
import cx from 'classnames';

import styles from './Flags.module.scss';

export interface Props {
  className?: Parameters<typeof cx>[0];
}

export const NL: React.FC<Props> = ({ className }) => (
  <i className={cx(styles.icon, className)}>
    <svg width={25} height={24} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path d='M24.5 8.99H.5v5.334h24V8.99z' fill='#fff' />
        <path d='M24.5 4H.5v5.333h24V4z' fill='#A2001D' />
        <path d='M24.5 14.667H.5V20h24v-5.333z' fill='#0052B4' />
      </g>
      <path d='M.5 4h24v16H.5z' stroke='#111' />
    </svg>
  </i>
);

NL.displayName = 'NL';
export default NL;
